import { CrudModel } from "./_crud";

export class SolutionCategoryModel extends CrudModel {
	constructor() {
		super("admin/category");
	}
}

export default new SolutionCategoryModel();
